export const actionTypes = {
  ON_REMOVE_ALL: 'onRemoveAllItems',
  ON_REMOVE: 'onRemoveItem',
  ON_ADD: 'onAddItem',
  ON_EDIT: 'onEditItem',
  ON_TOGGLE: 'onToggleAssistanceVisibility'
};

export const onToggleAssistanceVisibilityAction = (key) => ({
  type: actionTypes.ON_TOGGLE,
  payload: {
    key
  }
});

export const onRemoveAllItemsAction = (key) => ({
  type: actionTypes.ON_REMOVE_ALL,
  payload: {
    key
  }
});

export const onRemoveItemAction = ({ key, item }) => ({
  type: actionTypes.ON_REMOVE,
  payload: {
    key,
    item
  }
});

export const onAddItemAction = (key) => ({
  type: actionTypes.ON_ADD,
  payload: {
    key
  }
});

export const onEditItemAction = ({ key, item }) => ({
  type: actionTypes.ON_EDIT,
  payload: {
    key,
    item
  }
});
